import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import FactorySelector from "components/shared/FactorySelector";
import CompanySelector from "pages/manage/products/All/CompanySelector";
import { useState } from "react";
import { BsTrash } from "react-icons/bs";
import { GTM_PROJECT_CREATE_COMPONENT } from "./graphql";

const ComponentView = ({ originalComponent, project, index }) => {
  // Fix missing currency and unify CNY to RMB
  const initialCurrency = originalComponent.currency
    ? originalComponent.currency === "CNY"
      ? "RMB"
      : originalComponent.currency
    : "RMB";

  const [component, setComponent] = useState({
    ...originalComponent,
    nameCn: "",
    company: "UNSET",
    currency: initialCurrency,
    moq:
      originalComponent.prices.length > 0
        ? originalComponent.prices[0].minQty
        : 1,
    prices: originalComponent.prices.map((i) => ({
      company: "AB",
      currency: initialCurrency,
      minQty: i.minQty,
      price: i.price,
    })),
    syncToOdoo: true,
  });

  const [create, createRes] = useMutation(GTM_PROJECT_CREATE_COMPONENT, {
    onCompleted() {
      Alert("success", "Component created successfully");
    },
    onError(error) {
      window.alert("Error creating component: " + parseError(error));
    },
    refetchQueries: ["FETCH_GTM_PROJECT"],
  });

  const createHandler = () => {
    if (window.confirm("Are you sure you want to create this component?")) {
      create({
        variables: {
          gtmProjectId: project.id,
          name: component.name,
          nameCn: component.nameCn,
          number: component.number,
          company: component.company,
          supplierId: component.supplierId,
          moq: component.moq,
          prices: component.prices,
          gtmProjectComponentId: component.id,
          gtmProjectComponentName: component.name,
          syncToOdoo: component.syncToOdoo,
        },
      });
    }
  };

  return (
    <div className="card">
      <h5>Component #{index + 1}</h5>
      <div className="-mx-2 mt-4">
        <table className=" whitespace-nowrap">
          <tbody>
            <tr>
              <td>Company:</td>
              <td className="w-full">
                <CompanySelector
                  value={component.company}
                  onChange={(value) =>
                    setComponent({ ...component, company: value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Name:</td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={component.name}
                  onChange={(e) =>
                    setComponent({ ...component, name: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Name (Chinese):</td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={component.nameCn}
                  onChange={(e) =>
                    setComponent({ ...component, nameCn: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Number:</td>
              <td>
                <Input
                  className="w-full"
                  value={component.number}
                  onChange={(e) =>
                    setComponent({ ...component, number: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Suplier</td>
              <td>
                <FactorySelector
                  value={component.supplierId}
                  onChange={(value) =>
                    setComponent({ ...component, supplierId: value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Currency: </td>
              <td>
                <Select
                  value={component.currency}
                  onChange={(e) =>
                    setComponent({ ...component, currency: e.target.value })
                  }
                >
                  <option value="USD">USD</option>
                  <option value="RMB">RMB / CNY</option>
                </Select>
              </td>
            </tr>
            <tr>
              <td>MOQ:</td>
              <td>
                <Input
                  className="text-center"
                  type="number"
                  value={component.moq}
                  onChange={(e) =>
                    setComponent({ ...component, moq: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>Prices:</td>
              <td className="p-0">
                <table>
                  <tbody>
                    {component.prices.map((price, index) => (
                      <tr key={index}>
                        <td className="py-1">
                          <Select
                            value={price.company}
                            onChange={(e) =>
                              setComponent({
                                ...component,
                                prices: component.prices.map((p, i) =>
                                  i === index
                                    ? { ...p, company: e.target.value }
                                    : p,
                                ),
                              })
                            }
                          >
                            <option value="AB">AB</option>
                            <option value="LTD">LTD</option>
                          </Select>
                        </td>
                        <td>Min QTY:</td>
                        <td className="w-1/2 py-1">
                          <Input
                            className="w-full text-right"
                            value={price.minQty}
                            onChange={(e) =>
                              setComponent({
                                ...component,
                                prices: component.prices.map((p, i) =>
                                  i === index
                                    ? { ...p, minQty: e.target.value }
                                    : p,
                                ),
                              })
                            }
                          />
                        </td>
                        <td>Price:</td>
                        <td className="w-1/2 py-1">
                          <Input
                            className="w-full text-right"
                            value={price.price}
                            onChange={(e) =>
                              setComponent({
                                ...component,
                                prices: component.prices.map((p, i) =>
                                  i === index
                                    ? { ...p, price: e.target.value }
                                    : p,
                                ),
                              })
                            }
                          />
                        </td>
                        <td>
                          <Button
                            danger
                            onClick={() => {
                              setComponent({
                                ...component,
                                prices: component.prices.filter(
                                  (_, i) => i !== index,
                                ),
                              });
                            }}
                          >
                            <BsTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <Button
                          onClick={() => {
                            setComponent({
                              ...component,
                              prices: [
                                ...component.prices,
                                {
                                  price: "",
                                  minQty: 1,
                                  company: "AB",
                                  currency: initialCurrency,
                                },
                              ],
                            });
                          }}
                        >
                          + Add Price
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td>Sync to Odoo:</td>
              <td>
                <input
                  type="checkbox"
                  value={component.moq}
                  checked={component.syncToOdoo}
                  onChange={(e) =>
                    setComponent({
                      ...component,
                      syncToOdoo: !component.syncToOdoo,
                    })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="border-t dark:border-gray-700 pt-6 mt-6 space-y-4">
        <Button onClick={createHandler} loading={createRes.loading} primary>
          Create Product
        </Button>
      </div>
    </div>
  );
};

export default ComponentView;
